import { push } from '@lagunovsky/redux-react-router'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { H_CAMPAIGN_QUALITO_DASHBOARD } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import ProgressCard from '../../../components/card/ProgressCard'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import QualityCampaign from './QualityCampaign'
import { useParams } from 'react-router'


const QualityCampaignDashboard = () => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [progress, setProgress] = useState(0)

    const dispatch = useDispatch()
    const params = useParams()

    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_QUALITO_DASHBOARD)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
        }
        dispatch(CampaignAction.loadQualityCampaignDashboard(p => setProgress(p)))
            .then(() => setDataLoaded(true))
    }, [])

    if (!dataLoaded) {
        return <ProgressCard progress={progress} />
    }
    return (
        <QualityCampaign
            params={params}
        />
    )
}

export default QualityCampaignDashboard
